import React, { useState } from "react";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Switch,
  Box,
  Typography,
} from "@mui/material";
import { IHealthAreaItem } from "../../../api/mosaic/health_area";
import { editButtonSx } from "../../shared/buttonStyles";
import theme from "../../../utils/theme";
import SearchBar from "../../shared/SearchBar";

interface HealthAreaTableProps {
  isLoading: boolean;
  tableData: IHealthAreaItem[];
  handleEdit: (healthArea: IHealthAreaItem) => void;
  handleTogglePublish: (id: number, isPublished: boolean) => void;
}

const HealthAreaTable: React.FC<HealthAreaTableProps> = ({
  isLoading,
  tableData,
  handleEdit,
  handleTogglePublish,
}) => {
  const [search, setSearch] = useState("");

  if (isLoading) {
    return (
      <Box sx={{ textAlign: "center", py: 5 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (tableData.length === 0) {
    return (
      <Box sx={{ textAlign: "center", py: 5 }}>
        <Typography variant="body2" color="text.secondary">No health areas available</Typography>
      </Box>
    );
  }

  const filteredData = tableData.filter((row) =>
    row.name.toLowerCase().includes(search.toLowerCase()) ||
    row.icode.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <>
    <SearchBar value={search} onChange={setSearch} placeholder="Search health areas..." />
    <TableContainer sx={{ flex: 1, overflow: "auto" }}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell sx={{ backgroundColor: "#FAFAFA", fontWeight: 600 }}>Name</TableCell>
            <TableCell sx={{ backgroundColor: "#FAFAFA", fontWeight: 600 }}>Icode</TableCell>
            <TableCell sx={{ backgroundColor: "#FAFAFA", fontWeight: 600 }} align="center">Published</TableCell>
            <TableCell sx={{ backgroundColor: "#FAFAFA", fontWeight: 600 }} align="center">Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {filteredData.map((healthArea) => (
            <TableRow key={healthArea.id} hover>
              <TableCell>{healthArea.name}</TableCell>
              <TableCell>{healthArea.icode}</TableCell>
              <TableCell align="center">
                <Switch
                  checked={healthArea.isPublished}
                  onChange={() => handleTogglePublish(healthArea.id, !!healthArea.isPublished)}
                  sx={{
                    "& .MuiSwitch-switchBase.Mui-checked": { color: theme.palette.brand.success },
                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { backgroundColor: theme.palette.brand.secondary },
                  }}
                />
              </TableCell>
              <TableCell align="center">
                <Button variant="contained" onClick={() => handleEdit(healthArea)} sx={editButtonSx}>
                  Edit
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    </>
  );
};

export default HealthAreaTable;
